import { useSyncExternalStore } from "react";
import { authStore } from "./index";
import type { AuthSnapshot } from "./types";

export function useAuth(): AuthSnapshot {
  return useSyncExternalStore(
    authStore.subscribe,
    authStore.getSnapshot,
    authStore.getSnapshot,
  );
}
